import { createContext, useContext, useState } from "react";
import { FormProvider, UseFormReturn, useForm } from "react-hook-form";

export type EditModelAlbumFormInputs = {
  modelPhotoIds: string[];
};

type ModeType = "edit" | "view";

interface EditModelAlbumFormContextProps {
  form: UseFormReturn<EditModelAlbumFormInputs, any>;
  mode: ModeType;
  onSwitchMode: () => void;
}

const EditModelAlbumFormContext =
  createContext<EditModelAlbumFormContextProps>(null);

export const EditModelAlbumFormProvider = (props) => {
  const form = useForm<EditModelAlbumFormInputs>();
  const [mode, setMode] = useState<ModeType>("view");

  const onSwitchMode = () => {
    if (mode === "view") {
      setMode("edit");
      return;
    }

    setMode("view");
    form.reset({ modelPhotoIds: [] });
  };

  return (
    <EditModelAlbumFormContext.Provider value={{ form, mode, onSwitchMode }}>
      <FormProvider {...form}>{props.children}</FormProvider>
    </EditModelAlbumFormContext.Provider>
  );
};

export const useEditModelAlbumFormDialogContext = () =>
  useContext(EditModelAlbumFormContext);
